import { getSelectedLanguageCode } from '@/utils/commitmentStorage'
import { useTranslation } from 'react-i18next'

const LANGUAGE_KEY_BY_CODE: Record<string, string> = {
  en: 'pages.onboarding.languages.en',
  es: 'pages.onboarding.languages.es',
  de: 'pages.onboarding.languages.de',
  fr: 'pages.onboarding.languages.fr',
  it: 'pages.onboarding.languages.it',
  pt: 'pages.onboarding.languages.pt',
  nl: 'pages.onboarding.languages.nl',
  ja: 'pages.onboarding.languages.ja',
  zh: 'pages.onboarding.languages.ch',
  ko: 'pages.onboarding.languages.ko',
  ru: 'pages.onboarding.languages.ru',
  id: 'pages.onboarding.languages.in',
  pl: 'pages.onboarding.languages.pl',
  sv: 'pages.onboarding.languages.sv',
  tr: 'pages.onboarding.languages.tr',
}

export function useSelectedLanguageName() {
  const { t } = useTranslation()
  const code = getSelectedLanguageCode()
  const key = LANGUAGE_KEY_BY_CODE[code] ?? LANGUAGE_KEY_BY_CODE.en

  return t(key)
}
